var map = {
	"./aven.jpg": 64,
	"./b_.jpg": 65,
	"./gerhardundvladimir.jpg": 66,
	"./gstaad.jpg": 67,
	"./hess.jpg": 68,
	"./melnitschenko.jpg": 69,
	"./paykin.jpg": 70,
	"./pieth.jpg": 71,
	"./potanin.jpg": 72,
	"./putin.jpg": 73,
	"./readme.md": 102,
	"./rohstoff_1.jpg": 74,
	"./usmanov.jpg": 75,
	"./warning.jpg": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;